const PLACEHOLDER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid slice">
      <rect width="400" height="400" fill="#f3f4f6"/>
      <g fill="none" stroke="#d1d5db" stroke-width="2">
        <rect x="120" y="120" width="160" height="160" rx="8"/>
        <circle cx="170" cy="170" r="14"/>
        <path d="M130 260 L190 200 L230 240 L270 210 L270 270 L130 270 Z" fill="#e5e7eb" stroke="#d1d5db"/>
      </g>
      <text x="200" y="320" font-family="system-ui,sans-serif" font-size="14" fill="#9ca3af" text-anchor="middle">Image unavailable</text>
    </svg>`,
  );

export const IMG_PLACEHOLDER = PLACEHOLDER;

/**
 * Build <source> entries from an image_varients map.
 *   variants: { "1920": { path, image_alt }, "768": {...} }
 *   resolveUrl: (path) => absolute url
 * Renders smallest→largest as max-width media queries (art direction).
 * The largest variant is the default <img> fallback.
 */
const buildSources = (variants, resolveUrl) => {
  if (!variants || typeof variants !== "object") return null;
  const entries = Object.entries(variants)
    .map(([size, v]) => ({ size: Number(size), ...v }))
    .filter((e) => e.path && !Number.isNaN(e.size))
    .sort((a, b) => a.size - b.size);
  if (!entries.length) return null;
  return entries;
};

const Img = ({
  src,
  alt = "",
  className = "",
  id,
  width,
  height,
  priority = false,
  decoding = "async",
  fallbackOnErr = true,
  variants = null,
  resolveUrl = (p) => p,
}) => {
  const sources = buildSources(variants, resolveUrl);

  // No variants → plain img (backward compatible)
  if (!sources) {
    return (
      <img
        src={src || "err"}
        alt={alt}
        id={id}
        className={className}
        width={width}
        height={height}
        decoding={decoding}
        fetchPriority={priority ? "high" : "auto"}
        draggable={false}
        data-fallback-on-err={String(fallbackOnErr)}
      />
    );
  }

  // Art-direction: each variant maps to an exact image at its max-width breakpoint.
  // Largest variant = default <img> fallback (used above the biggest breakpoint).
  const largest = sources[sources.length - 1];

  return (
    <picture>
      {sources.slice(0, -1).map((s) => (
        <source
          key={s.size}
          media={`(max-width: ${s.size}px)`}
          srcSet={resolveUrl(s.path)}
        />
      ))}
      <img
        src={resolveUrl(largest.path)}
        alt={largest.image_alt || alt}
        id={id}
        className={className}
        width={width}
        height={height}
        decoding={decoding}
        fetchPriority={priority ? "high" : "auto"}
        draggable={false}
        data-fallback-on-err={String(fallbackOnErr)}
      />
    </picture>
  );
};

export default Img;
